import { useQuery } from '@apollo/client';
import LoadingIndicator from 'components/LoadingIndicator';
import Navbar from 'components/Navbar';
import QnAForm from 'components/QnA/QnAForm';
import {
  GET_PROMOTION_BY_USER,
  GetPromotionByUserResponse,
  getPromotionByUserVariables,
} from 'graphql/query/qna';
import {
  GET_USER_BY_ID_QUERY,
  GetUserByIdResponse,
  GetUserByIdVariables,
} from 'graphql/query/user';
import { useParams } from 'react-router-dom';
import { User } from 'types';
import { getSelectedObjectiveGoalsYear } from 'utils/common';

const ReporteePromotionQnA = () => {
  const { userId = '' } = useParams<{ userId: string }>();
  const { data: user, loading: loadingUsers } = useQuery<GetUserByIdResponse, GetUserByIdVariables>(
    GET_USER_BY_ID_QUERY,
    {
      variables: {
        user: userId,
        year: getSelectedObjectiveGoalsYear(),
      },
      fetchPolicy: 'network-only',
    }
  );

  const { data: promotionQnAs, loading: loadingPromotionQnA } = useQuery<
    GetPromotionByUserResponse,
    getPromotionByUserVariables
  >(GET_PROMOTION_BY_USER, {
    variables: { userId: userId, year: getSelectedObjectiveGoalsYear() },
  });

  return (
    <Navbar
      goBackButtonConfig={{
        title: 'Promotion Questions',
      }}
    >
      {loadingUsers || !!!user || loadingPromotionQnA ? (
        <LoadingIndicator />
      ) : (
        <QnAForm
          employee={user?.getUserById as User}
          initialQnAs={promotionQnAs?.getPromotionByUser ?? []}
        />
      )}
    </Navbar>
  );
};

export default ReporteePromotionQnA;
